//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    content: {
      required: true,
    },
  },
};
